import { render, staticRenderFns } from "./CommentsPanel.vue?vue&type=template&id=d356bf32&scoped=true"
import script from "./CommentsPanel.vue?vue&type=script&lang=js"
export * from "./CommentsPanel.vue?vue&type=script&lang=js"
import style0 from "./CommentsPanel.vue?vue&type=style&index=0&id=d356bf32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d356bf32",
  null
  
)

export default component.exports